var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconMedia = function SvgIconMedia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-media_svg__cls-1",
    d: "m8 4.18 3.2 2.13a.77.77 0 0 1 0 1.37L8 9.81c-.56.38-1 .13-1-.54V4.71c0-.71.46-.91 1-.53ZM15.3 2H2.7a.7.7 0 0 0-.7.7v8.6a.7.7 0 0 0 .7.7h12.6a.7.7 0 0 0 .7-.7V2.7a.7.7 0 0 0-.7-.7Zm0-2A2.7 2.7 0 0 1 18 2.7v8.6a2.7 2.7 0 0 1-2.7 2.7H2.7A2.7 2.7 0 0 1 0 11.3V2.7A2.7 2.7 0 0 1 2.7 0Z"
  })));
};

export default SvgIconMedia;